


























import Vue, { PropType } from 'vue';
import { mapGetters } from 'vuex';
import { BuyerType, MessageSource } from '@/constants';
import { Member, MessageData, MessageThread, User } from '@/types';
import { formatDateFormat, formatInTimeZone, getInitials } from '@/util';
import { generatelinkedText } from '../services/service';

export default Vue.extend({
  name: 'Message',
  data () {
    return {
      MessageSource
    }
  },
  props: {
    message: {
      type: Object as PropType<MessageData>,
      required: true
    },
    activeThread: {
      type: Object as PropType<MessageThread>,
      required: true
    },
    teamMembers: {
      type: Array as PropType<Member[]>,
      required: true
    },
    coBuyers: {
      type: Array as PropType<User[]>,
      required: true
    },
    isActiveThreadPostClose: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters(['user']),
    isSender (): boolean {
      return this.user.email === this.message.sender.email;
    },
    formatDate (): string {
      const time = formatInTimeZone(this.message.createdDate, 'h:mm a');
      if (formatDateFormat(new Date(), 'YYYY-MM-DD') === formatDateFormat(this.message.createdDate, 'YYYY-MM-DD')) {
        return `Today ${time}`;
      } else {
        return `${formatDateFormat(this.message.createdDate, 'MMM DD, YYYY')} ${time}`;
      }
    },
    formattedMessageData (): string {
      const doc = this.message.messageData;
      const linkedText = generatelinkedText(doc)
      return linkedText.replace(/\n/g, '<br />');
    },
    isTeamMemberActive (): boolean {
      if (this.message.sender.type === BuyerType.BUYER) {
        return (this.isSender || this.coBuyers.findIndex(cobuyer => cobuyer.email === this.message.sender.email) > -1) && this.isActiveThreadPostClose;
      }
      return this.teamMembers.findIndex(member => member.email === this.message.sender.email) > -1 && this.isActiveThreadPostClose;
    }
  },
  methods: {
    fetchInitials (firstName: string, lastName: string) {
      return getInitials(firstName, lastName);
    },
    getNamefromAttachmentUrl (url: string) {
      let fileName: string = url;
      if (url) {
        const urlArray = url.split('/');
        fileName = urlArray[urlArray.length - 1];
        const index = fileName.indexOf('-');
        fileName = fileName.substring(index + 1);
      }
      return fileName;
    }
  }
});

